import React, { useState } from "react";
import {
  Button,
  CssBaseline,
  Grid,
  Typography,
  Container,
  TextField,
  Select,
  InputLabel,
  MenuItem,
  Chip,
  Input,
  IconButton,
  InputAdornment,
} from "@material-ui/core/"
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import DateFnsUtils from "@date-io/date-fns";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import AppHeader from '../../../common/components/appHeader';
import AppFooter from '../../../common/components/appFooter';
import { email } from '../../../common/components/validations'
import * as CONSTANTS from '../../../common/constants/constants'
import useStyles from './styles';
import { useSnackbar } from 'notistack';
import { createNewPatient } from '../../../store/actions/addPatient';
import { useDispatch } from "react-redux";

/*
* Route: /add-patient
* Input (Props): -
* Purpose: Base container for Adding new patients
* Functionality: To add a new patient
*/

const AddPatientPage = () => {
  const classes = useStyles();
  const [patientData, setPatientData] = useState({
    mrn: "",
    dob: null,
    email: "",
    firstName: "",
    lastName: "",
    sex: "",
    password: "",
    countryCode: "us", // Hardcoded as of now. Might need to change it later.
    patientId: "",
    showPassword: false,
  });
  
  const initializePatient = () => {
    setPatientData({
      mrn: "",
      dob: null,
      email: "",
      firstName: "",
      lastName: "",
      sex: "",
      password: "",
      countryCode: "us", // Hardcoded as of now. Might need to change it later.
      patientId: "",
    })
  }


  const dispatch = useDispatch();
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const [emailError, setEmailError] = useState(false);
  const [dateError, setDateError] = useState(false);
  const [random, setRandom] = useState(Math.random());
  const reRender = () => setRandom(Math.random());

  const handleClickShowPassword = () => {
    setPatientData({ ...patientData, showPassword: !patientData.showPassword });
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  // Common Function to handle any Input feild change
  const handleDataChange = (e) => {
    let newData = patientData;
    newData[e.target.name] = e.target.value;
    setPatientData(newData);
    reRender(random);
  };

  // Common Function to handle date change
  const handleDateChange = (e) => {
    console.log(new Date(e.target.value))
    if(e.target.value == "Invalid Date")
      setDateError(true);
    else {
      const newDate = e.target.value;
      setPatientData(patientData => (
        {
          ...patientData,
          dob: newDate,
        }
      ))
      setDateError(false);
    }
  }

  // Function to create Patient on form submit
  const createPatient = (e) => {
    e.preventDefault()
    closeSnackbar();
    dispatch(createNewPatient(patientData, initializePatient, enqueueSnackbar, closeSnackbar));
  }

  return (
    <React.Fragment>
      <CssBaseline />
      <div className={classes.pageGlobal}>
        <AppHeader />
        <main className={classes.mainContent}>
          <div className={classes.heroContent}>
            <Container maxwidth="lg">
              <Typography component="h1" variant="h4" align="left">
                Add New Patient
              </Typography>
              <Chip
                color="primary"
                label=""
                className={classes.chip}
                size="small"
              />
            </Container>
          </div>
          <Container className={classes.cardGrid} maxwidth="lg">
            <Grid container spacing={4}>
              <Grid item xs={12} sm={12} md={12}>
                <Typography variant="h6" gutterBottom>
                  Patient Information
                </Typography>
                <Grid container spacing={3}>
                  <Grid item xs={5}>
                    <TextField
                      required
                      id="firstName"
                      name="firstName"
                      label="First Name"
                      fullWidth
                      value={patientData.firstName}
                      onChange={handleDataChange}
                    />
                  </Grid>
                  <Grid item xs={1}></Grid>
                  <Grid item xs={5}>
                    <TextField
                      required
                      id="lastName"
                      name="lastName"
                      label="Last Name"
                      fullWidth
                      value={patientData.lastName}
                      onChange={handleDataChange}
                    />
                  </Grid>
                  <Grid item xs={5}>
                    <TextField
                      required
                      id="mrn"
                      name="mrn"
                      label="Patient ID"
                      fullWidth
                      value={patientData.mrn}
                      onChange={handleDataChange}
                    />
                  </Grid>
                  <Grid item xs={1}></Grid>
                  <Grid item xs={5}>
                    <TextField
                      required
                      id="email"
                      name="email"
                      label="Email"
                      fullWidth
                      autoComplete="given-email"
                      value={patientData.email}
                      error={emailError}
                      onChange={(e) => { handleDataChange(e); setEmailError(email(e.target.value)) }}
                    />
                  </Grid>
                  <Grid item xs={2}>
                    <InputLabel id="sex">Sex</InputLabel>
                    <Select
                      required
                      labelId="Gender"
                      id="sex"
                      name="sex"
                      width="75%"
                      value={patientData.sex}
                      onChange={handleDataChange}
                      fullWidth
                    >
                      {
                        CONSTANTS.GENDER.map((item)=>{
                          return  <MenuItem value={item.value}>{item.label}</MenuItem>
                        })
                      }
                    </Select>
                  </Grid>
                  <Grid item xs={3}>
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                      <KeyboardDatePicker
                        autoOk
                        id="dob"
                        variant="inline"
                        format= {CONSTANTS.DATE_FORMAT.DATEPICKER_FORMAT.DATE}
                        label="Date Of Birth"
                        required
                        error={dateError}
                        disableFuture
                        value={patientData.dob}
                        onChange={(e) =>
                          handleDateChange({
                            target: { value: e, name: "dob" },
                          })
                        }
                        fullWidth
                      />
                    </MuiPickersUtilsProvider>
                  </Grid>
                  <Grid item xs={1}></Grid>
                  <Grid item xs={5}>
                  
                  <InputLabel htmlFor="standard-adornment-password">Password</InputLabel>
                    <Input
                      required
                      id="standard-adornment-password"
                      type={patientData.showPassword ? 'text' : 'password'}
                      name="password"
                      label="Password"
                      fullWidth
                      value={patientData.password}
                      onChange={handleDataChange}
                      endAdornment={
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            onClick={handleClickShowPassword}
                            onMouseDown={handleMouseDownPassword}
                          >
                            {patientData.showPassword ? <Visibility /> : <VisibilityOff />}
                          </IconButton>
                        </InputAdornment>
                      }
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={11} align="right" style={{ marginTop: "4rem" }}>
                <Button
                  href="#"
                  variant="contained"
                  color="primary"
                  type="submit"
                  className={classes.createButton}
                  disableElevation
                  size="large"
                  disabled={
                    !patientData.email ||
                    !patientData.mrn ||
                    !patientData.password ||
                    !patientData.sex ||
                    !patientData.firstName ||
                    !patientData.lastName ||
                    !patientData.dob ||
                    emailError ||
                    dateError
                  }
                  onClick={createPatient}
                >
                  Create new patient
                </Button>
              </Grid>
            </Grid>
          </Container>
        </main>
        <AppFooter />
      </div>
    </React.Fragment>
  );
};

export default AddPatientPage;